<template>
  <section
    class="ct-buttons"
    :class="`ct-buttons--${slice.Alignment}`"
  >
    <div class="ct-buttons__container container">
      <div class="content-type__content">
        <div
          v-if="slice?.Settings?.Title"
          class="content-type__heading heading heading--2"
        >
          {{ slice.Settings.Title }}
        </div>

        <p
          v-if="slice?.Settings?.Description"
          class="content-type__description"
        >
          {{ slice.Settings.Description }}
        </p>

        <div
          v-if="slice?.Buttons?.length"
          class="ct-buttons__list"
        >
          <template
            v-for="button in slice.Buttons"
            :key="button"
          >
            <component
              :is="getElement(button.Link)"
              v-if="button"
              :to="button.Link"
              class="ct-buttons__button button"
              :class="[`button--${useDash(button.Type)}`, {
                'button--small': button.Small,
              }]"
            >
              <component
                :is="loadIcon(button.IconLeft)"
                v-if="button.IconLeft"
                class="icon"
                :class="[`icon--${useDash(button.IconLeft)}`, {
                  'icon--arrow': button.IconLeft.includes('arrow'),
                }]"
              />
              <span>{{ button.Text }}</span>
              <component
                :is="loadIcon(button.IconRight)"
                v-if="button.IconRight"
                class="icon"
                :class="[`icon--${useDash(button.IconRight)}`, {
                  'icon--arrow': button.IconRight.includes('arrow'),
                }]"
              />
            </component>
          </template>
        </div>
        <!--  -->
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { AppLink } from '#components'

defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

function getElement(to: any) {
  return to ? AppLink : 'div'
}

const { loadIcon } = useStrapiIcons()
</script>

<style>
@import url("~layers/app/components/Slices/Buttons.css");
</style>
